import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.md,
  // 컬럼이 창 바닥까지 늘어나므로 이 카드가 그 세로를 받아 안쪽 주간 막대를 키운다.
  flex: 1,
  minHeight: 0,
  // 창을 최소 높이(600)까지 줄이면 주간 막대의 하한(160px)이 카드를 넘긴다.
  // 유리 테두리 밖으로 새는 대신 카드가 스크롤한다 (MonthlyCalendarHeatmap 과 같은 처리).
  overflowY: 'auto',
  backgroundColor: vars.surface.liquidGlass.innerSurface.background,
  backgroundImage: `radial-gradient(ellipse at 50% 40%, ${vars.opacityScale.whiteOverlay.light} 0%, transparent 40%, ${vars.opacityScale.blackOverlay.fade} 100%)`,
  backdropFilter: vars.surface.liquidGlass.backdropFilter.strong,
  border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  borderRadius: vars.spacing.borderRadius.lg,
  padding: vars.spacing.padding.md,
  boxShadow: `inset 0 0 20px ${vars.opacityScale.blackOverlay.medium}, inset 0 1px 0 ${vars.opacityScale.whiteOverlay.veil}, inset 0 -2px 6px ${vars.opacityScale.blackOverlay.strong}, 0 0 6px ${vars.bright.primary.glow}`,
});
